import { ColorOptions, numberValidation, required, Spacer, Text, TextInputNewProps } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { Dropdown } from '../../components/Dropdown'
import { AutoSettle } from './AutoSettle'
import { Toggle } from './Toggle'

const textStyle = {
  fontFamily: 'jiotype-medium',
  fontSize: 12,
  color: 'PRIMARY_GREY' as ColorOptions,
}
const textInputStyle = {
  fontSize: 14,
  color: 'BLACK_21',
  placeholderTextColor: 'PRIMARY_GREY',
  borderColor: 'PRIMARY_GREY',
  borderRadius: 4,
  padding: 8,
} as TextInputNewProps
export const formData = (isEditable: boolean, frequencies: any) => {
  return [
    {
      formItems: [
        {
          horizontalComps: [
            {
              fieldName: 'label1',
              displayName: 'label1',
              ComponentName: Text,
              title: 'Frequency ID',
              ...textStyle,
            },
            {
              fieldName: 'frequencyId',
              ComponentName: Dropdown,
              selectable: isEditable,
              minWidth: 140,
              title: 'Frequency ID',
              validationSchema: required,
              data:
                frequencies?.length > 0
                  ? frequencies
                  : [
                      { id: '1', value: '1' },
                      { id: '2', value: '2' },
                      { id: '3', value: '3' },
                      { id: '4', value: '4' },
                      { id: '5', value: '5' },
                      { id: '6', value: '6' },
                      { id: '7', value: '7' },
                      { id: '8', value: '8' },
                    ],
            },
          ],
        },
        {
          fieldName: 'autoSettleDays',
          ComponentName: AutoSettle,
          editable: isEditable,
          validationSchema: numberValidation,
          ...textInputStyle,
        },
        {
          horizontalComps: [
            {
              fieldName: 'label4',
              displayName: 'label4',
              ComponentName: Text,
              title: 'Settlement on Hold',
              ...textStyle,
            },
            {
              fieldName: 'settlementOnHold',
              ComponentName: Toggle,
              disabled: !isEditable,
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'label5',
              displayName: 'label5',
              ComponentName: Text,
              title: 'Post Recon',
              ...textStyle,
            },
            {
              fieldName: 'isDynamicSettlement',
              ComponentName: Toggle,
              disabled: !isEditable,
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'label8',
              displayName: 'label8',
              ComponentName: Text,
              title: 'Remarks',
              ...textStyle,
            },
            {
              fieldName: 'remarks',
              ComponentName: TextInputNew,
              editable: isEditable,
              placeholder: 'Remarks',
              ...textInputStyle,
            },
          ],
        },
        {
          fieldName: 'spacer8',
          ComponentName: Spacer,
          direction: 'vertical',
          size: 8,
        },
      ],
      horizontalFlex: 1,
      onSubmit: () => {
        return 'end'
      },
    },
  ]
}
